module.exports = __webpack_public_path__ + "static/divas2s-c9c8b99e64dda79b4bbfe459cc97585f.jpg";